import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { MissionControl } from './pages/MissionControl';
import { AutomationStudio } from './pages/AutomationStudio';
import { FanHub } from './pages/FanHub';
import { Settings } from './pages/Settings';
import { WebsiteStudio } from './pages/WebsiteStudio';
import { PressKit } from './pages/PressKit';
import { SearchVisibility } from './pages/SearchVisibility';
import { LaunchPlan } from './pages/LaunchPlan';
import { DraftPreview } from './pages/DraftPreview';
import { Backstage } from './pages/Backstage';
import { ArtistWebsite } from './pages/ArtistWebsite';
import { AboutPage } from './pages/AboutPage';
import { EpkPage } from './pages/EpkPage';
import { StudioLogin } from './pages/StudioLogin';
import { loadStudioSession, onStudioSessionChange, type StudioSession } from './data/teamAccess';
import { startWebsiteCloudSync } from './data/website';
function PrivateApp() {
  const [session, setSession] = useState<StudioSession | null>(null);
  const [checking, setChecking] = useState(true);
  useEffect(() => {
    let active = true;
    void loadStudioSession().then(found => {
      if (!active) return;
      setSession(found);
      setChecking(false);
    });
    const unsubscribe = onStudioSessionChange(next => {
      if (active) setSession(next);
    });
    return () => {
      active = false;
      unsubscribe();
    };
  }, []);
  if (checking) {
    return <div className="flex min-h-screen w-full items-center justify-center bg-ink-900" data-id="element-0" data-mp="33myjb79kwfrj">
        <p className="text-[13px] text-zinc-500" data-id="element-1" data-mp="38k6x6vnp1xmz">Checking your sign-in…</p>
      </div>;
  }
  if (!session) return <StudioLogin onSignedIn={setSession} data-id="element-2" data-mp="3dirw8rr7mb9u" />;
  return <AppShell session={session} onSignOut={() => setSession(null)} data-id="element-3" data-mp="nuhgse7ce3s6">
      <Routes data-id="element-4" data-mp="sudk0b87tr6o">
        <Route path="/" element={<MissionControl data-id="element-6" data-mp="stc7e2bjwwmu" />} data-id="element-5" data-mp="su427axbqqc2" />
        <Route path="website" element={<WebsiteStudio data-id="element-8" data-mp="36861i5q6iv0" />} data-id="element-7" data-mp="swqajcs1h9vc" />
        <Route path="press-kit" element={<PressKit data-id="element-10" data-mp="34ndtz6vvc0b" />} data-id="element-9" data-mp="35gnb7x88fm5" />
        <Route path="search" element={<SearchVisibility data-id="element-12" data-mp="3udkmfuysas9v" />} data-id="element-11" data-mp="3uct25gan0gyw" />
        <Route path="launch" element={<LaunchPlan data-id="element-14" data-mp="3uf5g7id9y76o" />} data-id="element-13" data-mp="3uc9inv5c9kir" />
        <Route path="preview" element={<DraftPreview data-id="element-16" data-mp="d3cw3t2oyyh3" />} data-id="element-15" data-mp="d57f31uekgij" />
        <Route path="fans" element={<FanHub data-id="element-18" data-mp="85uj9rljzz3t" />} data-id="element-17" data-mp="d2l8b4fc651d" />
        <Route path="automation" element={<AutomationStudio data-id="element-20" data-mp="864djrdmssfb" />} data-id="element-19" data-mp="85bd1859mz5m" />
        <Route path="settings" element={<Settings data-id="element-22" data-mp="3gklb8561bk84" />} data-id="element-21" data-mp="3gle8mfj3sxdl" />
      </Routes>
    </AppShell>;
}
export function App() {
  // Pulls the site down from the band's own database, then keeps it fresh, so
  // every device and every visitor sees the same content.
  useEffect(() => {
    startWebsiteCloudSync();
  }, []);
  return <BrowserRouter data-id="element-23" data-mp="3ljxygr0titb8">
      <Routes data-id="element-24" data-mp="3ljphoo1kr3ur">
        {/* Public, fan-facing pages */}
        <Route path="/" element={<ArtistWebsite data-id="element-26" data-mp="2xu3ku78od0px" />} data-id="element-25" data-mp="2xuwr773q1o7j" />
        <Route path="/website" element={<ArtistWebsite data-id="element-28" data-mp="2xsk4kgn0qpo5" />} data-id="element-27" data-mp="2xtby7lx22dbs" />
        <Route path="/about" element={<AboutPage data-id="element-30" data-mp="2sv0qphu8gewq" />} data-id="element-29" data-mp="2swbuvirlbood" />
        {/* Press kit — intentionally unlinked from the public navigation. */}
        <Route path="/epk" element={<EpkPage data-id="element-32" data-mp="18bolyqu3ijz2" />} data-id="element-31" data-mp="18c6o243fvsew" />
        <Route path="/backstage" element={<Backstage data-id="element-34" data-mp="1d5j9k5ctnj3f" />} data-id="element-33" data-mp="1d47wtg1ef106" />
        {/* Private management app */}
        <Route path="/studio/*" element={<PrivateApp data-id="element-36" data-mp="ygmsjissevqo" />} data-id="element-35" data-mp="yfv9f7gdmqha" />
      </Routes>
    </BrowserRouter>;
}